import {MatDialog, MatSnackBar,MatCheckboxChange} from '@angular/material';
import {ActivatedRoute, Router} from '@angular/router';
import {MapClickHandler, MapComponent, ClickDisplay} from '../../map.component'
import {Constants,Log} from '../../../../commons/Constants';
import { AnnotationType } from '../../../../commons/global';
import {Annotation, Transform, Dataset, FourDService} from '4d-mapper'
import {MapService} from '../../../../commons/map.service';
import {BaseComponent} from '../../../../commons/BaseComponent';
import {MeasurementHelperService, AnnotationShapes} from '../../../../service/measurement-helper.service';
import {EntityHelperService} from '../../../../service/entity-helper.service';
import {ShapeMaker} from '../../../../commons/ui/shape-maker';
import {Location} from '@angular/common';
import { XsApplicationEventsService } from '../../../../xs/services/events/application-events.service';
import { OnDestroy, HostListener, OnInit } from '@angular/core';
import { InspectionComponent } from '../../list-views/inspect.component';
import { Subject, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { CoordZone } from '@src/app/service/coord-helper.service';
import { PluginManagerService } from '@src/app/service/plugin-manager.service';
import { XsAwait } from '@src/app/xs/controllers/await.class';
import { FileManagementService } from '@src/app/service/file-manager.service';
import { EpsgHelperService } from '@src/app/service/epsg-helper.service';

const Cesium = (<any>window).Cesium


/*
    BaseAnnotationComponent
    -----------------------
    Handles all events and functionality

  */


export class BaseAnnotViewer extends BaseComponent  implements MapClickHandler, OnInit, OnDestroy {

  debug:boolean = Constants.debug_off;
  debugMe2:string = '%c base_annot %c ';

  debugStyle:string = Constants._blue;
  debugStyleMouse:string = Constants._black;
  debugStyleEvent:string = Constants._orange;
  debugStyleFunc:string = Constants._green;

  // all the data for our current Annotation
  annotation: Annotation;

  // if we have an icon, this is it!
  icon: string;

  // categories for this Annotation
  categories:any = [];

  // what type of Annotation am I?
  type:string = null;
  protected types:any = AnnotationType;

  // local viewer reference
  // viewer:any = null;

  /* refactor effort: this base class is a sordid mess of state and direct drawing, so we need
    to untangle it to fix the many problems with it. As refactoring is solid, the variables used
    will appear below this comment. */


  // incoming mode of annotation (new or old)
  isNewAnnotation:boolean = false;

  // normally the annotation id, but if it's a new annotation, we need to make not 'undefined', but '0'
  currentAnnotationRef:number = null;

  // currently selected shape
  // selectedShape:number = null;

  // currently selected point
  // selectedPoint:number = null;

  // if we're creating something, here's the entity used
  creationEntityId:any = null;
  creationConfig:any = null;

  // hack : bug in Cesium prohibits us from pulling positions from a poly-shape with less than 2 points, so we need a local version instead
  creationPoints:any = [];

  // an entity that's just been dragged (usually a handle)
  draggableHandleObj: any = null;

  // cached mouse check handler
  hasCheckedMousePosition:any = null;

  // active coordinates of mouse cursor and clicks
  screenCoordsCartesian: any = new Cesium.Cartesian3(0, 0, 0);
  screenCoords: any = {lat: null, lng: null, height: null};

  // view states
  viewColors:boolean = false;
  viewIcons:boolean = false;
  viewCategories:boolean = true;
  viewCalc:boolean = false;

  showCalculateOptions:boolean = false;

  filesAttached:any[] = [];

  // refactored screenshot handling
  screenshots:any = [];

  // if we've got plugins attached (by the component, not automatically through a controller)
  plugins:any = [];

  // for screenshot features (old code, just copied in from Pin.component)
  screenshotByteCharacters: any;
  screenshotName: any;
  deletingScreenShot: boolean;
  protected canDeleteScreenshot: boolean;

    // show ghostlines when drawing new items (default for all, but multi-points shouldn't use them)
    useGhostlines:boolean = true;

  // a slightly better way to capture a reference to an existing photo
  photoTransform:Transform

  // zone for grid calculations; needs to be a bit base for fast access to it
  zone:CoordZone = null;
  
  // if this component becomes active, what's its name?
  activeTab(){
    return 'annot'
  }

  // for simple category additions
  addTagFn(name) {
    return { label: name };
  }

  // overridden in base_measure.component as needed
  onLeftDownClick(movement) {}
  onLeftUpClick(movement) {}
  onMouseMove(movement) {}



    // cesium viewer ready
    private _viewerReadySubj = new Subject<any>();
    private _viewerReadyObs = this._viewerReadySubj.asObservable();
    onViewerReady() { return this._viewerReadyObs; }


  constructor(protected route: ActivatedRoute, public router: Router, snackBar: MatSnackBar, dialog: MatDialog, public mapComp: MapComponent, 
    public mapService: MapService, public mappingHelper: MeasurementHelperService, public entityHelper: EntityHelperService, 
    public applicationEvents:XsApplicationEventsService, public epsgHelper: EpsgHelperService, public fileManager: FileManagementService ){
    super(router, snackBar, dialog);

    console.log ( '%c base_annot.comp %c constructor', Constants._yellow, Constants._yellow, this.debugMe, this );

    // Cesium-specific shapeMaker helper class for now (until refactoring with the /v2 way of doing things)
    this.shapeMaker = new ShapeMaker( this.mapService, this.mappingHelper, this.entityHelper );


    // if navigating from link, make sure default tab is annotations
    this.mapComp.setTab(this.activeTab())

    // set some initial state
    this.mapComp.activeDetails = this
    this.mapComp.showBalloon = false
    this.loading = true

    // we need Cesium and the viewer for all our operations, so we use a local reference as a check (for all subscriptions, etc.)
    // we either get it (because it's ready), or we subscribe and wait for it to become ready

    

  /*
    if ( mapService.viewer ) {

      if ( this.debug ) { console.log ( '%c base_annot.comp %c sub -> CESIUM READY 1', Constants._red, Constants._red);}
      this.viewer = mapService.viewer;
      this._viewerReadySubj.next();

    } else {
      this.mapService.onCesiumReady().subscribe( _ => {
        if ( this.debug ) { console.log ( '%c base_annot.comp %c sub -> CESIUM READY 2', Constants._red, Constants._red);}
        this.viewer = mapService.viewer;
        this._viewerReadySubj.next();
      });
    }

    // subscribe to any incoming changes through the URL. If there's no viewer yet, wait for it to become ready
    this.route.params.subscribe(s => {
      if ( this.viewer ) {
        this.incomingRouteSubscriptions ( s );
      } else {
        this.onViewerReady().subscribe( _ => {
          this.incomingRouteSubscriptions ( s );
        });
      }
    });
*/
  }

  // initialise component (often after the annotation data is loaded)
  onInit() {

    // this ne loads the annotation (new or old)
    this.route.params.subscribe(s => {
      if ( this.debug ) { console.log ( this.debugMe2 + 'onInit() ROUTE', Constants._blue, Constants._orange, s );  }
        this.incomingRouteSubscriptions ( s );
    });

    if ( this.debug ) { console.log ( this.debugMe2 + 'onInit() awaiting ...', Constants._blue, Constants._orange );  }

    // all of the stuff happening after needs the map ...
    XsAwait.until(['mapService.viewer','annotation'], this ).then ( _ => {

      if ( this.debug ) { console.log ( this.debugMe2 + 'onInit() awaited, got viewer', Constants._blue, Constants._orange );  }

      this.mapService.viewer = this.mapService.viewer;

      

      this.addSubscription( 'singleImageAttach',
        this.mapService.onSingleImageForAttachementChange.subscribe(t => {
  
          // this is the shaz, still terrible but about 90% less terrible hack
          this.photoTransform = t
          this.annotation['photoTransform'] = null;
          // this.annotation.saveObservable().subscribe()
  
          if(this.screenshotName || this.canDeleteScreenshot){
            this.deleteScreenShot(false);
          }
          const reader = new FileReader();
          reader.readAsDataURL(t['screenshotByteCharacters']);
          this.annotation['screenshotByteCharacters'] = t['screenshotByteCharacters'];
          reader.onloadend = () => {
            this.screenshotByteCharacters  = reader.result;
            this.save();
          }
        })
      )

      this._viewerReadySubj.next();

      this.onInitDone();

    });
/*
    if ( this.debug ) { console.log ( this.debugMe2 + 'onInit() ----------------------------- --------------------------------- ------------------------------', Constants._blue, Constants._orange );  }
    if ( this.viewer ) {
      this.onInitDone();
    } else {
      this.onViewerReady().subscribe( _ => {
        if ( this.debug ) { console.log ( this.debugMe2 + 'onInit() sub -> onViewerReady()', Constants._blue, Constants._orange );  }
        this.onInitDone();
      });
    } */
  }

  onInitDone() {

    if ( this.debug ) { console.log ( this.debugMe2 + 'onInitDone() ----------------------------- --------------------------------- ------------------------------', Constants._blue, Constants._orange );  }

    // a few good keyboard event listeners
    this.boundKeyboardDown = this.keyDown.bind(this)
    this.boundKeyboardUp = this.keyUp.bind(this)
    window.addEventListener('keydown', this.boundKeyboardDown, false);
    window.addEventListener('keyup', this.boundKeyboardUp, false);

    if ( this.debug ) { console.log(this.debugMe2 + 'onInit() :: ['+this.constructor.name+'] LOOKING FOR THE VIEWER ', Constants._blue, Constants._green, this.mapService.viewer ); }


    // handler for all things interaction on the map (mouse, mostly)
    this.mouseHandler = new Cesium.ScreenSpaceEventHandler(this.mapService.viewer.scene.canvas);

    if ( this.debug ) { console.log(this.debugMe2 + 'onInit() :: ['+this.constructor.name+'] NOW CONTROL THE MOUSE EVENTS ', Constants._blue, Constants._green, this.mapService.viewer.scene, this.mapService.viewer.scene.canvas ); }

    // set up left-down-click handler
    this.mouseHandler.setInputAction((movement) => {
      this.onLeftDownClick(movement);
    }, Cesium.ScreenSpaceEventType.LEFT_DOWN);

    // set up left-up-click handler
    this.mouseHandler.setInputAction((movement) => {
      this.onLeftUpClick(movement);
    }, Cesium.ScreenSpaceEventType.LEFT_UP);

    // set up mouse movement handler
    this.mouseHandler.setInputAction((movement) => {
      this.onMouseMove(movement);
    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);

/*
    this.addSubscription(
      this.mapService.newAnnotationReady.subscribe(_ => {
        console.log ( this.debugMe + 'onInit() SUBSCRIPTION mapService.newAnnotationReady', Constants._blue, Constants._orange );
        this.onAnnotationReady();
      })
    );
*/

  }



  incomingRouteSubscriptions ( s:any ) {

    if ( this.debug ) { console.log ( '%c base_annot.comp %c sub -> route.params', this.debugStyle, this.debugStyleEvent, this.debugMe, s, this.annotation );}

    // if there's already one there, it means this same component is getting a new one and we need to clear old cruft
    if ( this.annotation ) {
      this.shapeMaker.unselectPoint();
      this.shapeMaker.unselectShape ();
      this.shapeMaker.destroy( this.annotation );
    }

    // for a brand new Annotation
    if(s.id == 'new'){

      if ( this.debug ) { console.log ( '%c base_annot.comp %c sub -> route.params NEW', this.debugStyle, this.debugStyleEvent, this.debugMe, this.mapService.newAnnotation);}
      this.createNewAnnotation();
    }

    // for incoming identifiers, we try to load the Annotation from the backend
    else if(s.id){

      if ( this.debug ) { console.log ( '%c base_annot.comp %c sub -> route.params EXISTING', this.debugStyle, this.debugStyleEvent, this.debugMe );}
      this.loadExistingAnnotation ( s.id );
    }

    if ( this.annotation ) {
      if ( !this.annotation.hasOwnProperty('showPermanent')) {
        if ( this.debug ) { console.log ( '%c base_annot.comp %c sub -> NO_SHOW_PERMANENT()', this.debugStyle, this.debugStyleEvent, this.debugMe );}
        this.annotation['showPermanent'] = true;
      }
    }

    // set the map views tabs to annotations
    if ( this.debug ) { console.log ( '%c base_annot.comp %c sub -> setTab()', this.debugStyle, this.debugStyleEvent, this.debugMe, this.annotation );}
    this.mapComp.setTab(this.activeTab());

    // open details draw
    if ( this.debug ) { console.log ( '%c base_annot.comp %c sub -> open detailsNav()', this.debugStyle, this.debugStyleEvent, this.debugMe );}
    this.mapComp.detailsNav.open();

  }

    /* refactor effort: this base class is a sordid mess of state and direct drawing, so we need
    to untangle it to fix the many problems with it.  */

  createNewAnnotation() {

    if ( this.debug ) { console.log ( this.debugMe2 + 'createNewAnnotation()', this.debugStyle, this.debugStyleFunc ); }

    // create new Annotation
    this.annotation = this.mapService.newAnnotation;

    this.isNewAnnotation = true;

    // successful
    if(this.annotation){

      this.loading = false;
      this.onAnnotationLoaded( true );

      // force shapes to be blank (in case old gremlins of the undefined Annotation id still roams)
      this.annotation['shapes'] = [];

    // fail
    } else {
      // just go back (hackish simple solution; we need better handling here later)
      window.history.back();
    }
  }

  loadExistingAnnotation( id:string ) {

    if ( this.debug ) { console.log ( this.debugMe2 + 'loadExistingAnnotation()', this.debugStyle, this.debugStyleFunc );}

    // try to find it
    this.annotation = this.mapService.annotations.find(a => a.id == parseInt(id));

    // if id given but not found (odd circumstances)
    if(!this.annotation){

      this.isNewAnnotation = false;

      this.mapComp.fourD.V.searchByObject(Annotation).useCache(true).equals('id',id).queryObservable().subscribe(res => {

        if ( this.debug ) { console.log ( this.debugMe2 + 'loadExistingAnnotation() after search', this.debugStyle, this.debugStyleFunc, res );}

        // if found the right Annotation
        if(res.items.length){
          // transfer the new annotation over
          this.annotation = res.items[0];
          this.onAnnotationLoaded();
        }
        this.loading = false;
      },
      e => {
        this.openSnackBarError(e.message);
        this.loading = false;
      });
    }

    // successfully found and loaded the Annotation from the backend
    else {

      if ( this.debug ) { console.log ( this.debugMe2 + 'loadExistingAnnotation() existing', this.debugStyle, this.debugStyleFunc, this.annotation );}

      this.annotation['saved'] = undefined;
      this.loading = false;

      this.onAnnotationLoaded();
    }
  }

  onAnnotationLoaded( isCreate:boolean = false ){

    if ( this.debug ) { console.log ( this.debugMe2 + 'onAnnotationLoaded() ------------------------------------------------ ', this.debugStyle, this.debugStyleEvent, this.entityHelper.init());}

    // Shaz hack but still better than old way
    if(this.annotation['photoTransform']){
      this.photoTransform = null
      // load the full transform reference for this obj
      this.mapService.fourD.V.searchByObject(Transform).equals('id',this.annotation['photoTransform'].id).queryObservable().subscribe(res => {
        if(res.items.length){
          this.photoTransform = res.items[0]
        }
        else
          delete this.annotation['photoTransform']
      })
    }

    // pick out the type for a handy shortcut
    this.type = this.annotation['annotationMode'];

    // why are we setting the newAnnotation (temporary helper for new) to the loaded annotation?
    this.mapService.newAnnotation = this.annotation;
    // this.mapService.newAnnotationReady.next();

    // make a sane annotation id reference
    this.currentAnnotationRef = this.annotation.id ? this.annotation.id : 0;

    // get a list of all files attached to this annotation
    this.getAttachedFiles();

    // console.log('## annotation attachments', this.fileManager );

    this.fileManager.getAttachments(this.annotation).then( files => {
      // console.log('## annotation attachments results', files );
    });

    // some blank defaults
    if(!this.annotation.hasOwnProperty('attributes')){
      this.annotation['attributes'] = [];
    }
    if(!this.annotation.hasOwnProperty('categories')){
      this.annotation['categories'] = [];
    }
    if(!this.annotation.hasOwnProperty('showLabels')){
      this.annotation['showLabels'] = true;
    }
    if(!this.annotation['shapes']){
      // if no Shapes, try to convert from old format
      this.annotation['shapes'] = this.mappingHelper.convertFromOldFormat ( this.annotation );
    } else {
      if ( this.annotation['shapes'] instanceof Array ) {
        // test incoming format, and if bad, try to re-convert from old
        if ( ! this.mappingHelper.testFormat ( this.annotation['shapes'] ) ) {
          this.annotation['shapes'] = this.mappingHelper.convertFromOldFormat ( this.annotation );
        }
      }
    }

    // if ( ! isCreate ) {
      this.onAnnotationReady();
    // }

  }


  // annotation is ready and loaded
  onAnnotationReady() {

    this.shapes = this.annotation['shapes'];

    if ( this.debug ) { console.log ( this.debugMe2 + 'onAnnotationReady() --------------------------------------------------', Constants._blue, Constants._orange, this.annotation ); }

    if ( this.type == AnnotationType.multipoi ||  this.type == AnnotationType.poi ) {
      this.useGhostlines = false;
    }

    if ( this.isNewAnnotation ) {

      // starts the cursor and sets the mode
      this.createShape();

      // create the shape and entities, and fills them with incoming coords
      this.startCreateShape();

    } else {

      // load our helper with our shapes
      this.shapeMaker.loadShapes ( this.annotation );

      let initial_shape = this.annotation['shapeRef'] ? this.annotation['shapeRef'] : 0;

      // select a shape (0 means find first one)
      this.shapeMaker.selectShape ( initial_shape, this.shapes );

      this.annotationUpdated();

      // auto-calculate?
      if ( this.autoCalculate ) {
        this.calculate();
      }

    }

    this.flipCalcLabels();

    if ( this.type == AnnotationType.poi ) {
      this.endCreateShape();
    }


    // console.log ( this.debugMe2 + 'onAnnotationReady() -------- END', Constants._blue, Constants._orange, this.shapeMaker.selectedShape );

    // old code

    /*

    if (this.annotation) {
      if ( this.debug ) { console.log ( 'base_measure.comp :: onAnnotationReady()'); }
      if (this.annotation.id) {
        this.drawFromSavedAnnotation();
      } else if (this.mapComp.movement && this.annotation['annotationMode'] !== 'flyToLine') {
        if ( this.debug ) { console.log ( 'base_measure.comp :: onAnnotationReady() Annotation BUT NO Annotation ID, but map movement (and not flyToLine). When does this ever happen?'); }
        this.onLeftClick(this.mapComp.movement);
      }
      if (this.annotation['annotationMode']) {
        this.mode = this.annotation['annotationMode'];
      }
    } else {
      if ( this.debug ) { console.log ( 'base_measure.comp :: onAnnotationReady() [but NO Annotation] ??'); }
    }
    */
  }


  onDestroy() {

    if ( this.debug ) { console.log ( this.debugMe2 + 'onDestroy() ---------------------------------------------------', Constants._blue, Constants._orange, this.mapService); }

    // refactor; this Destroy can also be useful for Pins, currently here is only for other Annotations

    try {

      if ( this.shapeMaker ) {
        this.shapeMaker.ghostlineEnd();
        this.shapeMaker.destroy( this.annotation ) ;
      }

      // not sure why we enable this on Destroy?
      this.enableCameraMotion(true);

      // refactor; this is de-selecting in the inspection component (should be either a function call, or handled on that side)
      this.mapComp.inspectorComp.selected = null;

      // if user navigate to other url without saving then enable the checkbox in inspectorComp
      if (this.mapComp.inspectorComp.annotationShowPermanentTemp) {
        this.mapComp.inspectorComp.showHideAnnotation(this.annotation,{currentTarget:{ checked:false }});
      }

      // if there's any cursors lurking
      this.endCursorMovements();

      // remove mouse handler
      if (this.mouseHandler) {
        this.mouseHandler.destroy();
        this.mouseHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
        this.mouseHandler.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE);
      }

      // remove keyboard listeners
      window.removeEventListener('keydown', this.boundKeyboardDown);
      window.removeEventListener('keyup', this.boundKeyboardUp);

      // clean up our subscriptions
      this.deleteSubscriptions();

      if ( this.plugins && this.plugins.length ) {
        this.plugins.forEach ( plugin => {
          plugin.destroy();
        })
      }

      if ( this.annotation ) {

        //remove unsaved annotation from cesium abnormal destroy of component
        // not sure if still needed?
        if (this.annotation['saved'] == undefined) {
          if (this.annotation && !this.annotation.id) {
            this.mapService.deleteAnnotation(this.annotation).subscribe();
          } else {
            this.mapService.newAnnotation = undefined;
          }
        }

      }


    } catch (e) {
      console.error(e);
    }
  }

  flipCalcLabels () {
    // console.log ( '%c base_annot.comp %c flipCalcLabels()', this.debugStyle, this.debugStyleMouse, this.annotation['showLabels'] );
    if ( this.annotation['showLabels'] ) {
      this.shapeMaker.turnHandleLabelsOn();
    } else {
      this.shapeMaker.turnHandleLabelsOff();
    }
  }


  // helper for closing the detailsNav box on a click
  clickCloseAnnotation( doCheck:boolean = true ) {
    setTimeout (()=>{
      this.onAnnotationClosing( doCheck );
      this.mapComp.detailsNav.close();
    },500);
  }

  onAnnotationClosing( doCheck:boolean = true ) {
    if ( doCheck && this.isNewAnnotation ) {
      this.openDialog( "GENERIC.SAVE_DATA", "MAP.SAVE_ANNOTATION", 'GENERIC.YES', 'GENERIC.NO' ).subscribe( a => {
        if ( a ) {
          this.save(true);
        }
        this.closeAnnotation();
      });
    } else {
      this.closeAnnotation();
    }
  }

  closeAnnotation( force:boolean = false) {

    // clean up if we've got a delete option hanging
    this.shapeMaker.unselectPoint();

    // stop cursors if they were enabled
    this.endCursorMovements();

    // clear any leftovers
    this.shapeMaker.unselectShape ( this.shapes );

    // also kill all handles
    this.shapeMaker.destroy( this.annotation );

    // setting selector to null forces the component (inside detailsNav) to destroy
    this.mapComp.inspectorComp.setSelected(null,true,'base_annot:closeAnnot()');

  }



  /*
    Mousy stuff
  */

clickedMap(movement: any, rightClick: boolean, checkedPosition):ClickDisplay { return ClickDisplay.None; }

  // if ( this.debug ) { console.log ( '%c base_annot.comp %c clickedMap()', this.debugStyle, this.debugStyleMouse );}

/*
 // get distance between clicked point and center of screen
  var clickedCartesian = this.mapService.viewer.scene.pickPosition(movement.position);
  var windowCenter = new Cesium.Cartesian3(this.mapService.viewer.canvas.width / 2 , this.mapService.viewer.canvas.height / 2);
  var center = this.mapService.viewer.scene.pickPosition(windowCenter);
  var direction = new Cesium.Cartesian3();

  Cesium.Cartesian3.subtract(center, clickedCartesian, direction);
  Cesium.Cartesian3.normalize(direction, direction);
  var amount = Cesium.Cartesian3.distance(clickedCartesian, center);
  //this.mapService.viewer.camera.move(direction, amount);

*/
/*
  if(this.mapService.isCameraClicked){ // show images around the clicked point when camera button is clicked in pin mode
    return this.mapComp.activeTabObj.clickedMap(movement,false, checkedPosition);

  }else if(!rightClick) {
    if(!this.annotation.id)
      this.openConfirmDelete(() => {
        this.mapService.setNewAnnotation(null)
        this.mapComp.inspectorComp.setSelected(null)
      },this.annotation.name || 'New annotation')
    else{
      this.mapComp.inspectorComp.setSelected(null)
      return ClickDisplay.Chevron
    }
  } else{
    return ClickDisplay.None;
  }
}
*/

// cached checked object for what we find in a Cesium map
checkedMousePosition ( movement ) {

  let check = this.hasCheckedMousePosition = this.mappingHelper.checkMousePosition ( movement, true );

  /*
  if ( this.mappingHelper.cached ) {
    return this.mappingHelper.cached;
  }
  // check what's at the current mouse position
  let check = this.hasCheckedMousePosition;
  if ( ! check ) {
    check = this.hasCheckedMousePosition = this.mappingHelper.checkMousePosition ( movement, true );
  }
  */
  return check;
}



  save(force:boolean = false){

    if ( this.debug ) { console.log ( '%c base_annot.comp %c save()', this.debugStyle, this.debugStyleMouse, force, this.isNewAnnotation ); }

    // if we're a new annotation, but we're not forcing the save (as in, the final save) then we're not really saving yet
    if ( this.isNewAnnotation && ! force ) {
      return;
    }

    // if ( this.debug ) { console.log ( '%c base_annot.comp %c save()', this.debugStyle, this.debugStyleMouse, force, this.isNewAnnotation );}

    // if(this.mapComp.inspectorComp.annotationShowPermanentTemp){
    //   if ( this.debug ) { console.log ( '%c base_annot.comp %c save() annotationShowPermanentTemp', this.debugStyle, this.debugStyleMouse, this.mapComp.inspectorComp.annotationShowPermanentTemp ); }
    //   this.mapComp.inspectorComp.showHideAnnotation(this.annotation,{currentTarget:{ checked:false }});
    // }
    // this.removeAnnotationProps();
    if (this.shapes){
      let data = this.mappingHelper.getGeoJSON(this.annotation);
      this.finishUpdatingAnnotation(data, force);
    }else{
      this.finishUpdatingAnnotation(null, force);
    }
  }


  private finishUpdatingAnnotation(data:any = null, force:boolean = false ) {

    let screenshotByteCharacters;
    if(this.annotation['screenshotByteCharacters'] ){
      screenshotByteCharacters = this.annotation['screenshotByteCharacters'];
      this.annotation['screenshotByteCharacters'] = undefined;
    }

    let toAddAsNewAnnotation = false;
    if(!this.annotation.id){ // remove annotation from sdk having undefined id and add it again so new annotation can be placed in proper location
      this.mapService.helper.removePlottable(this.annotation);
      toAddAsNewAnnotation = true;
    }

    // set the activeSceneId in the annotation
    this.annotation['sceneId'] = this.mapService.scene.id;

    // convert all Cartesian3 coords to standard objects (the backend serialiser doesn't like Cartesian objects)
    this.annotation['shapes'] = this.mappingHelper.prepareForSerialising ( this.shapes );

    // console.log ( '%c !!!', Constants._red, this.annotation );
    // return;

    // OK, save the thing!
    this.mapService.updateAnnotation(this.annotation).subscribe( a => {

      if ( this.debug ) { console.log ( '%c base_annot.comp %c save() done', this.debugStyle, this.debugStyleMouse, a );}

      // this.annotation.id has got new ID by this stage for newly created annotations
      if ( this.isNewAnnotation ) {

        // update all old ('0') references to the new id
        this.entityHelper.changeShapesAnnotationRef ( this.annotation );

        // save again with references fixed
        this.mapService.updateAnnotation(this.annotation).subscribe();
      }

      if( screenshotByteCharacters ){ // if annotation has screenshot then upload
        this.uploadScreenShot(screenshotByteCharacters);
      }

      if(toAddAsNewAnnotation && this.annotation['annotationMode'] === 'poi'){
        this.mapService.helper.setPlottable(this.annotation).subscribe(res => {
          let pin = res.object.pin;
          if ( this.debug ) { console.log ( '%c base_annot.comp %c finalUpdate() REFRESH ENTITY', this.debugStyle, this.debugStyleMouse, res, pin );}
          if ( pin ) {
            pin['type'] = 'poi';
            pin['__type'] = 'poi';
            pin.billboard.image = InspectionComponent.getPin(res.plottable);
          }
        });
      }

      // this.openSnackBarInfo('GENERIC.SAVED');
      if(data){
        this.mappingHelper.sendFile(data, this.annotation, this.snackBar, this.mapComp);
      }
    }, e=> this.openSnackBarError(e.message))

  }

  // override at will
  annotationUpdated() { 
    console.log('annotationUpdated() [saved]'); 
  }


  del(){
    this.openConfirmDelete( () => {
      this.mapService.deleteAnnotation(this.annotation).subscribe(s => {
        this.mappingHelper.deleteAnnotationShapes ( this.annotation );
        this.onAnnotationClosing(false);
        this.mapComp.inspectorComp.setSelected(null,true,'base_annot:del()');
      })
    },this.annotation.name);
  }



  /*
    Create shapes
  */




  // creation of shapes

  callbackGetPositions() {
    let ret = this.creationPoints ? this.creationPoints : [];
    // console.log ('----',ret);
    return ret;
  }

  // create a new shape for this annotation (the creation starts on a mouseClick, which will call startCreateShape() below)
  createShape() {
    // this.debug = true;
    if ( this.debug ) { console.log ( '%c base_annot %c createShape()', this.debugStyle, this.debugStyleFunc ); }

    // reset state
    this.creationEntityId = null;
    this.creationPoints = [];
    this.creationConfig = null;

    // start the cursor, waiting for the next click
    this.interactionMode = 'create';
    this.translate.get("MAP.START_SHAPE").subscribe(text => this.startCursorMovements( text ) )
  }

  // when called, it creates a new shape with all that's needed in it
  startCreateShape() {

    let type = this.annotation['annotationMode'];

    // unselect all shapes
    this.shapeMaker.unselectShape ( this.shapes );


    // start with the last known clicked coordinates
    let coord = this.screenCoordsCartesian;

    // any incoming or existing coordinates?
    if ( this.isNewAnnotation && this.annotation['clickedLast'] ) {

      // transfer over
      coord = this.annotation['clickedLast'];

      if ( this.debug ) { console.log ( '%c base_annot %c startCreateShape() * ' + type, this.debugStyle, this.debugStyleFunc, this.annotation['clickedLast'] ); }

      // don't fall in this trap more than once
      this.annotation['clickedLast'] = null;
    }

    // our local hold of positions in a new shape
    this.creationPoints.push ( coord );

    if ( this.debug ) { console.log ( '%c base_annot %c startCreateShape() 0', this.debugStyle, this.debugStyleFunc, this.screenCoordsCartesian, this.isNewAnnotation, this.annotation['clickedLast'], coord );}

    let newshapeidx = this.shapes.length;

    // create a new blank shape
    let newshape = {
      annotationRef: this.currentAnnotationRef,
      positions: this.creationPoints,
      shapeRef: newshapeidx,
      entityRef: null,
      color: 'rgba(255,80,10,0.8)',
      lineWidth: 4,
      clamping: type === 'line'? false : true,
      points: [{ point: 'xx', coords: coord }],
      shapeInfo: true,
      showOptions: true
    }

    if ( type === 'line' ) { /* || type === 'area' || type === 'volume' */
      let me = this;
      newshape['positionsCallbackThis'] = me;
      newshape['positionsCallback'] = this.callbackGetPositions;
      /* new Cesium.CallbackProperty( function () { 
        console.log ( '**********************************', me.creationPoints);
        return me.creationPoints 
      }, false); */
    }

    // push the new shape into the shapes
    this.shapes.push (newshape);

    if ( this.debug ) { console.log ( '%c base_annot %c startCreateShape() 1', this.debugStyle, this.debugStyleFunc, this.creationPoints, newshapeidx, newshape, this.shapes );}

    this.creationEntityId = this.mappingHelper.createAnnotationShape ( this.annotation, newshapeidx, newshape );
    
    if ( this.debug ) { console.log ( '%c base_annot %c startCreateShape() 2', this.debugStyle, Constants._red, newshapeidx, newshape, this.shapes, this.creationEntityId );}


    // successfully created an entity?
    if ( this.creationEntityId ) {

      // just set the new selected shape index, but don't create any handles yet
      this.shapeMaker.selectedShape = newshapeidx;

      // console.log ( '%c base_annot %c selectedShape :: startCreateShape()', this.debugStyle, Constants._red );
    }

    let check = {
      new: this.entityHelper.getEntity ( this.creationEntityId ),
      action:null,
      feature:null,
      props: {
        shapeRef: newshapeidx,
        entityRef: this.creationEntityId,
        pointRef:0,
        typeRef:'new_point'
      }
    }

    if ( this.debug ) {

      console.log ( '%c base_annot %c startCreateShape() END 5', this.debugStyle, this.debugStyleFunc,
        coord, newshape, this.shapes, this.hasCheckedMousePosition );

      console.log ( '%c base_annot %c startCreateShape() END 3', this.debugStyle, this.debugStyleFunc,
        this.entityHelper.getEntityProperties(this.creationEntityId), this.creationEntityId,
        this.entityHelper.getEntity ( this.creationEntityId ), this.annotation );
    }

    // if ( this.annotation['annotationMode'] == AnnotationType.poi ) {
    //   this.endCreateShape();
    //   return;
    // }

    // start a ghostline (from first position to the cursor)
    this.shapeMaker.ghostlineStart( check, this.useGhostlines );

    this.creationConfig = newshape;
  }

  clickWhileCreateShape( check:any ) {

    // if there's already a shape
    this.translate.get(["MAP.ADD_ANOTHER","MAP.FINISH_SHAPE"]).subscribe(params => {
      this.changeCursorTooltip ( this.creationPoints.length < 1 ? params["MAP.ADD_ANOTHER"] : params["MAP.FINISH_SHAPE"] );
    })

    // if there's no entity yet, create one
    if ( ! this.creationEntityId ) {

      if ( this.debug ) { console.log ( '%c base_annot %c clickWhileCreateShape no entity', this.debugStyle, this.debugStyleFunc, check ); }

      // send the checks to the shapeMaker
      this.shapeMaker.dragHandleStart ( check, this.useGhostlines );

      // this also creates the first point, so skip the next section
      this.startCreateShape();

    } else {

      // push in the newly clicked point
      this.creationPoints.push(this.screenCoordsCartesian);

      if ( this.creationConfig && this.creationConfig['positionsCallbackThis'] ) {

        // callback updates the positions; do nothing here
        // console.log('DOING NOTHING', this.creationPoints);

      } else {

        // we got to update our entity with the points

        // get the entity in charge
        let e = this.entityHelper.getEntity ( this.creationEntityId );

        this.entityHelper.entityChange ( 'coords', e, this.creationPoints, true );
      }

      // transfer our points to the shapes array (with the odd sub-object style)
      this.transferCoordsToShapes( this.creationPoints );

      if ( this.debug ) { console.log ( '%c base_annot %c clickWhileCreateShape update', this.debugStyle, this.debugStyleFunc,
          this.creationEntityId, this.creationPoints ); }
    }
  }

  // transfer incoming points (array of Cartesian3 coordinates) to the shapes array (with the odd sub-object style)
  transferCoordsToShapes ( coords:any[] ) {

    // console.log ( '%c AAA', this.shapeMaker.selectedShape, this.shapes[this.shapeMaker.selectedShape] );

    if ( ! this.shapes[this.shapeMaker.selectedShape] ) {
      return null;
    }

    let points = this.shapes[this.shapeMaker.selectedShape].points;

    if ( !coords || coords.length < 1 || ! points ) {
      return null;
    }

    coords.forEach(function (value, i) {
      let point = { point:'zz', coords: value };
      if ( points[i] ) {
        points[i] = point;
      } else {
        points.push(point);
      }
    });

  }

  endCreateShape() {

    if ( this.debug ) { console.log ( '%c base_annot %c endCreateShape()', this.debugStyle, this.debugStyleFunc, this.shapes ); }
    this.interactionMode = 'select';

    if ( this.creationConfig ) {
      let e = this.entityHelper.getEntity ( this.creationEntityId );
      if ( e && e.polyline && e.polyline ) {
        let p = e.polyline.positions;
        e.polyline.positions = p.getValue();
        // console.log ( '@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@', e.polyline, v );
      }
      if ( this.creationConfig['positionsCallbackThis'] ) {
        this.creationConfig['positionsCallbackThis'] = undefined;
      }if ( this.creationConfig['positionsCallback'] ) {
        this.creationConfig['positionsCallback'] = undefined;
      }
      this.creationConfig = null;
    }

    this.beforeUpdateShape();

    // switch off the cursor
    this.endCursorMovements();

    // delete/remove the ghostline
    this.shapeMaker.ghostlineEnd();

    if ( this.creationPoints.length < 2 ) {
      this.deleteShape ( this.shapes.length );
    } else {
      this.updateShape( this.shapes.length - 1 );
    }

    // auto-calculate?
    if ( this.autoCalculate ) {
      this.calculate();
    }

  }

  deleteShape ( shape:number = 1, check:any = null ) {

    let fromShape = this.shapeMaker.selectedShape;
    this.beforeUpdateShape();

    let entityRef = this.entityHelper.getEntityId ( this.currentAnnotationRef, shape );

    // move all shapeRef down a notch
    for ( let shape_idx = this.shapes.length; shape_idx >= 0; shape_idx--) {
      let prev_id = this.entityHelper.getEntityId ( this.currentAnnotationRef, shape_idx + 1 );

      // no prev means the last item, so we can delete it
      if ( !prev_id ) {
        this.entityHelper.deleteEntityId ( this.currentAnnotationRef, shape );
      } else
      if ( shape_idx >= shape ) {
        this.entityHelper.updateEntityId ( this.currentAnnotationRef, shape, prev_id );
      }
    }

    // surgery!
    this.shapes.splice ( shape, 1 );
    this.entityHelper.destroyEntity ( entityRef );

    // console.log ( '%c base_annot %c selectedShape :: deleteShape()', this.debugStyle, Constants._red, this.shapeMaker.selectedShape );
    this.updateShape( fromShape - 1 );
    
  }

  deletePoint ( point:number = 0, check:any ) {

    let fromShape = this.shapeMaker.selectedShape;

    this.beforeUpdateShape();
    this.shapes[fromShape].points.splice ( point, 1 );

    let shapeRef = check.props.shapeRef;
    // let entityRef = this.testEntityRefIntegrity ( shapeRef, check.props.entityRef );
    let entityRef = this.entityHelper.getEntityId ( this.currentAnnotationRef, shapeRef );

    this.entityHelper.setEntityProperty ( 'show', entityRef, false );

    let positions = this.shapeMaker.getShapeAsPositions ( shapeRef, this.shapes );
    this.entityHelper.setEntityProperty ( 'coords', entityRef, positions );
    this.updateShape( fromShape );

    this.entityHelper.setEntityProperty ( 'show', entityRef, true );

  }

  insertPointAt ( point:number = 0, check:any ) {
    let fromShape = this.shapeMaker.selectedShape;
    this.beforeUpdateShape();
    this.shapes[fromShape].points.splice ( point + 1, 0, { point:'yy', coords: this.screenCoordsCartesian } );

    let shapeRef = check.props.shapeRef;
    let entityRef = this.entityHelper.getEntityId ( this.currentAnnotationRef, shapeRef );

    let positions = this.shapeMaker.getShapeAsPositions ( shapeRef, this.shapes );
    this.entityHelper.setEntityProperty ( 'coords', entityRef, positions );
    this.updateShape( fromShape );
  }

  testEntityRefIntegrity ( shapeRef:number, entityRef:string ) {
    let shape_idx = -1;
    // for each shape
    this.shapes.forEach ( function (current_shape) {
      shape_idx++;
      this.shapes[shapeRef].entityRef = this.annotation['shapes'][shapeRef].entityRef;
    }, this);

    return this.shapes[shapeRef].entityRef;
  }

  beforeUpdateShape () {

    // console.log ( '%c base_annot %c beforeUpdateShape()', this.debugStyle, Constants._red, this.shapeMaker.selectedShape );

    // unselect all
    this.shapeMaker.unselectPoint();
    this.shapeMaker.unselectShape( this.shapes );

    // first remove all handles
    this.shapeMaker.destroy( this.annotation );
  }

  // when a shape has been updated (mostly meaning, added or deleted points)
  updateShape ( shape:number ) {

    // console.log ( '%c base_annot %c updateShape()', this.debugStyle, Constants._red, shape, this.shapeMaker.selectedShape );

    // before we re-load shapes, make sure the Annotation gets the latest version
    this.annotation['shapes'] = this.shapes;

    // then recreate them
    this.shapeMaker.loadShapes ( this.annotation );

    // console.log ( '  ----- BASE AREA CALCULATE ------', this.autoCalculate );

    // auto-calculate?
    if ( this.autoCalculate ) {
      this.calculate();
    }

    this.save();

    // re-select
    this.shapeMaker.selectShape ( shape, this.shapes );

    this.annotationUpdated();

  }




 // cursors

 changeCursorTooltip ( msg:string = '' ) {

   if ( this.mouseCursor )  this.mouseCursor.label.text = msg;
 }
 startCursorMovements( msg:string = '' ) {

  if ( this.mouseCursor ) {
    // already one, so kill it before going on
    this.endCursorMovements();
  }
// [Adam] this was causing cesium depth buffer picking issue on pointclouds and returning null for pickPoistion function (a main cause that picking,dragging was failing and cesium was fighting hard in the start to render drawings!)
  this.mouseCursor = this.mapService.viewer.entities.add ({
    name: 'cursor',
    /* billboard : {
      image : 'assets/images/icons/add.png',
      color: Cesium.Color.WHITE.withAlpha(0.9),
      disableDepthTestDistance:Number.POSITIVE_INFINITY,
      width:26, height:26
    }, */
    label: {
        text: msg,
        font : '13px sans-serif',
        pixelOffset: new Cesium.Cartesian2(-82, -42),
        horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
        verticalOrigin: Cesium.VerticalOrigin.TOP,
        disableDepthTestDistance: Number.POSITIVE_INFINITY
    }
  });
  
  if ( this.debug ) { console.log ( '%c base_annot %c startCursor()', this.debugStyle, this.debugStyleFunc, this.mouseCursor ); }
}

endCursorMovements() {
  if ( this.mouseCursor ) {
    this.mapService.viewer.entities.remove ( this.mouseCursor );
    if ( this.debug ) { console.log ( '%c base_annot %c endCursor()', this.debugStyle, this.debugStyleFunc ); }
  }
}


  // Setting property / entity color/width/etc.

  setCurrentColor(event, shape:number) {

    // get the entity
    let me = this.entityHelper.getEntityId ( this.currentAnnotationRef, shape );
    // let shapes = this.mappingHelper.getShapes ( this.annotation );

    if ( me && this.shapes ) {
      // change the color of the original entity
      this.entityHelper.entityChange ( 'color', me, this.shapes[shape].color );
      this.save();
    }
  }

  setCurrentLineWidth(shape:number = 0) {

    // get the entity
    let me = this.entityHelper.getEntityId ( this.currentAnnotationRef, shape );

    if ( me && this.shapes ) {
      // change the lineWidth of the original entity
      this.entityHelper.entityChange ( 'lineWidth', me, this.shapes[shape].lineWidth );
      this.save();
    }

  }

  setClampToModel(event: MatCheckboxChange, shape:number = 0) {

    let me = this.entityHelper.getEntityId ( this.currentAnnotationRef, shape );
    if ( me && this.shapes ) {
      // change the clamping of the original entity
      this.entityHelper.entityChange ( 'clamping', me, this.shapes[shape].clamping );
      this.save();
    }
  }

  setShapeInfo(event: MatCheckboxChange, shape:number = 0) {

    let me = this.entityHelper.getEntityId ( this.currentAnnotationRef, shape );
    if ( me && this.shapes ) {
      // change the shapeInfo of the original entity
      this.entityHelper.entityChange ( 'shapeInfo', me, this.shapes[shape].shapeInfo );
      this.save();
    }
  }

  // generic navigation and func

  flyTo ( idx:number = 0 ) {
    if ( this.shapes && this.shapes[idx] ) {
      let id = this.shapes[idx]['entityRef'];
      // console.log ( '%c base.comp %c flyTo('+idx+')', id);
      if ( id ) {
        let e = this.entityHelper.getEntity ( id ) ;
        if ( e ) {
          this.mapService.viewer.flyTo ( e, { duration:0.9} );
        }
      }
    }
  }

  // not sure how this one works yet (@alex)
  enableCameraMotion(state) {
    this.mapService.viewer.scene.screenSpaceCameraController.enableRotate = state;
    this.mapService.viewer.scene.screenSpaceCameraController.enableZoom = state;
    this.mapService.viewer.scene.screenSpaceCameraController.enableLook = state;
    this.mapService.viewer.scene.screenSpaceCameraController.enableTilt = state;
    this.mapService.viewer.scene.screenSpaceCameraController.enableTranslate = state;
  }


  // generic functionality for all annotations (images/inspection, image attachements, key/value attributes, etc.)
  // refactor; most of these are just copied over from other components, so beware of bugs

  /* show images either in a tab or a window */
  showImages(isCameraClicked: boolean) {

    // console.log ( 'showImages()', this.annotation);

    this.mapService.isCameraClicked = isCameraClicked;
    this.mapComp.openPhotoBucket();
    this.mapService.refreshPhotos( this.annotation.catresian() ).subscribe()
    // this.mapComp.setTab('image');
  }

  addAttrib(){
    this.annotation['attributes'].push({key:'',value:''});
  }
  delAttrib(i){
    this.annotation['attributes'].splice(i, 1);
  }

  openURL(annotation: Annotation) {
    let url: string = '';
    if (!/^http[s]?:\/\//.test(annotation['externalURL'])) {
      url += 'http://';
    }
    url += annotation['externalURL'];
    window.open(url, '_blank');
  }

  openExternalLink() {
    var inp = {value: ''}
    if (this.annotation['externalURL']) {
      inp.value = this.annotation['externalURL'];
    }
    this.openDialog('MAP.EXTERNAL_LINK', '', null, null, inp, true).subscribe(res => {
      if (res) {
        // console.log(res);
        this.annotation['externalURL'] = res;
        this.annotation.saveObservable().subscribe();
      }
    })
  }

  getAttachedFiles() {
    // console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@ get attached");
    if(this.annotation.id){
      this.mapComp.service.V.api('/api/Annotation/' + this.annotation.id + '.files').subscribe( value => {
        this.filesAttached = value;
        // console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@ got attached",value);
    
      });
    }
  }

  checkScreenshot( shotName:string ) {
    if ( this.screenshotByteCharacters ) {
      this.screenshotName = shotName;
    }
  }

  getScreenShotByAnnotation() {
    if(this.annotation.id){
      this.mapComp.service.V.api('/api/Annotation/' + this.annotation.id + '.files')
        .subscribe(
          value => {
            if (value.length > 0) {
              this.screenshotName = value[0].name;
            }
          }
        );
    }
  }

  deleteScreenShot ( cur:any ) {

    let find = this.filesAttached.find ( f => f.name == cur.name );
    // console.log ( 'delete!!!!!!',cur,this.filesAttached, find );
    
    //this.deletingScreenShot = true;
    //this.photoTransform = null
    //delete this.annotation['photoTransform']
    //delete this.annotation['screenshotByteCharacters']
    //this.annotation.saveObservable().subscribe()
    if(this.annotation.id && find ){
      this.mapComp.service.V.api('/api/Annotation/' + this.annotation.id + '/' + find.name, 'delete')
        .subscribe(
          value => {
            this.getAttachedFiles();
            // this.screenshotName = undefined;
            // if(canDeleteBytes) // to avoid race condition while capturing screenshot
            //   this.annotation['screenshotByteCharacters'] = undefined;
            // this.deletingScreenShot = false;
          },
          error1 => this.deletingScreenShot = false
        );
    }else{
      this.screenshotByteCharacters = undefined;
    }
  }

  uploadScreenShot(byteCharacters) {
    let d = new Date();
    let imageName = d.getTime() + '.png';

    var xhr = new XMLHttpRequest();
    var upload = xhr.upload;
    upload.addEventListener('progress', (evt) => {
      if (evt.lengthComputable) {
        /* self.progress = ((self.loaded + evt.loaded) / self.total);
        self.progressSubject.next(self.progress)*/
        // console.log(evt);
        // this.loadExistingAnnotation( '' + this.annotation.id ) ;
      }
    }, false);

    xhr.onreadystatechange = () => {
      if (xhr.readyState === XMLHttpRequest.DONE) {

        if (!xhr.responseText || xhr.responseText === '') {
          this.snackBar.open(Constants.ERROR_MESSAGE, '', {duration: Constants.SNACKBAR_DURATION});
          return;
        }
        // good response
        var res = JSON.parse(xhr.responseText);
        if (res.status && res.status === 200) {
          {
            this.snackBar.open(Constants.SUCCESS_MESSAGE, '', {duration: Constants.SNACKBAR_DURATION});
            // this.openSnackBarSuccess(Constants.SUCCESS_MESSAGE);
            
          }
          // console.log('all good',res);
          this.getAttachedFiles();
          // all good
        } else if (res.status && res.status < 400) {
          // console.log('vasat error');
          this.snackBar.open(Constants.ERROR_MESSAGE, '', {duration: Constants.SNACKBAR_DURATION});
        } else {
          this.snackBar.open(Constants.ERROR_MESSAGE, '', {duration: Constants.SNACKBAR_DURATION});
        }
      }
    };

    xhr.open('POST', this.mapComp.fourD.V.config.host + '/api/Annotation/' + this.annotation.id + '/' + imageName);
    xhr.overrideMimeType('application/octet-stream');
    xhr.setRequestHeader('Content-Type', 'application/octet-stream')
    xhr.setRequestHeader('Authorization', 'Bearer ' + this.mapComp.fourD.V.token)
    xhr.send(byteCharacters);
  }

  gotCoordinates() {
    if ( this.mapComp && this.mapComp.currentCoord )  { return this.mapComp.currentCoord.position; }
    return null;
  }
  gotVerticalOffset() {
    if ( this.mapComp && this.mapComp.vertical_offset )  { return this.mapComp.vertical_offset; }
    return null;
  }
  refreshPhotosFromCurrentCoord() {
    this.mapService.refreshPhotos( this.gotCoordinates(), this.gotVerticalOffset() ).subscribe();
  }

  deleteAttachedPhotos() {
    this.annotation.photoIds = [];
    this.openSnackBarSuccess('PROJECT.DIALOG.PHOTOS_DETACHED');
    this.refreshPhotosFromCurrentCoord();
  }

  browsePhotos() {
    this.openDialogWithModeAndFilterAndMeta({
      project: this.mapService.currentProject
    }, 'file', 'Dataset', 'PROJECT.DIALOG.ADD_TRANSFORM_TITLE', 'PROJECT.DIALOG.ADD_TRANSFORM_TEXT',).subscribe(dest => {
      // console.log(dest);
        if (dest && Array.isArray(dest) && dest.length > 0) {
          try{
            if (this.annotation.photoIds) {
              dest.filter(d => d.dataType && d.dataType.uid === 'photo').map(o => o.transformIds.map(e => this.annotation.photoIds.push(e)));
              var photos = new Array<number>();
              // removing duplicate ids
              this.annotation.photoIds = this.annotation.photoIds.filter(value => {
                if (photos.indexOf(value) === -1) {
                  photos.push(value);
                  return true;
                } else {
                  return false;
                }
              });

            } else {
              this.annotation.photoIds = [];
              dest.filter(d => d.dataType && d.dataType.uid === 'photo').map(o => o.transformIds.map(e => this.annotation.photoIds.push(e)));
            }
            this.refreshPhotosFromCurrentCoord();
            this.openSnackBarSuccess('PROJECT.DIALOG.PHOTOS_ATTACHED');
          }catch (e) {
            this.openSnackBarSuccess('PROJECT.DIALOG.PHOTOS_ERROR', e.message);
            console.log(e)
          }

        }
      },
      e => this.openSnackBarError(e.message, null)
    )

  }

  showDZI(t:Transform){
    this.openDZIDialogWith(t,'TYPES.photo-dzi')
  }
}
